const MENTION_TYPE = "mention";
export {
  MENTION_TYPE
};
//# sourceMappingURL=types.js.map
